<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <div class="container-fluid content-type-20">
            <div class="container">
                <div class="row row-content">
                    <div class="col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
                        <div class="content">
                            <OnboardingStepOne v-if="currentStep === 1" />
                            <OnboardingStepTwo v-if="currentStep === 2" />
                            <OnboardingStepThree v-if="currentStep === 3" />
                            <OnboardingStepFour v-if="currentStep === 4" />
                        </div>
                    </div>
                    <div class="col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
                        <div class="buttons">
                            <button class="btn-s-icon" :class="[currentStep < 2 ? 'btn-disabled' : currentStep >= steps ? 'btn-2' : 'btn-2']" :disabled="currentStep < 2" @click="setStep(null, 'back')">
                                <span>{{$t('views.onboarding.buttons.back')}}</span>
                            </button>
                            <button class="btn-1 btn-s-icon" :disabled="currentStep >= steps" v-if="currentStep < steps" @click="setStep()">
                                <span>{{$t('views.onboarding.buttons.next')}}</span>
                                <div class="icon-arrow-neg"></div>
                            </button>
                            <button class="btn-4 btn-s-icon button-skip" @click="setOnboardingStatus(1)">
                            <!-- <button class="btn-s-icon button-skip" :class="currentStep >= steps ? 'btn-1' : 'btn-4'" @click="setOnboardingStatus(1)"> -->
                                <!-- <span>{{$t(currentStep >= steps ? 'views.onboarding.buttons.finish' : 'views.onboarding.buttons.skip')}}</span> -->
                                <span>{{$t('views.onboarding.buttons.skip')}}</span>
                                <!-- <div v-if="currentStep >= steps" class="icon-arrow-neg"></div> -->
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AccountViewBase>
</template>

<script>
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import OnboardingStepOne from '@/components/accountOnboarding/OnboardingStep1';
    import OnboardingStepTwo from '@/components/accountOnboarding/OnboardingStep2';
    import OnboardingStepThree from '@/components/accountOnboarding/OnboardingStep3';
    import OnboardingStepFour from '@/components/accountOnboarding/OnboardingStep4';
    import { scrollToTop } from '@/utils/scroll';

    export default {
        name: 'OnboardingView',
        components: {
            AccountViewBase,
            OnboardingStepOne,
            OnboardingStepTwo,
            OnboardingStepThree,
            OnboardingStepFour
            
        },
        mixins: [i18nViewMixin, accountMixin],
        data() {
            return {
                seo_title: 'views.onboarding.seo_title',
                loaded: false,
                loadingView: false,
                currentStep: 1,
                steps: 4
            };
        },
        computed: {
            loading() {
                return this.accountLoading || this.loadingView;
            },
        },
        methods: {
            setStep(step = null, direction = 'next') {
                this.currentStep = step || direction === 'back' ? Math.max(this.currentStep - 1, 1) : this.currentStep + 1;
            },
            async setOnboardingStatus(status) {
                await this.accountStore.updateAccount({
                    onboarding_status: status
                });

                if(status === 1) {
                    this.$router.push({ name: "companies" });
                }
            }
        },
        watch: {
            currentStep() {
                this.$nextTick(() => {
                    scrollToTop();
                });
            }
        },
        async mounted() {
            if(this.account.onboarding_status !== 0) {
                this.loadingView = true;
                await this.setOnboardingStatus(0);
                this.loaded = true;
                this.loadingView = false;
            }
        }
    }
</script>
